import { Button, Col, Form, Input, Row, Select, Table } from "antd";
import React, { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import { dropdownService, loadingPlanService } from "../../../services";
import { useNavigate } from "react-router-dom";

function GenerateLoadPlan() {

  const navigate = useNavigate()
  const { id } = useParams();
  const [form] = Form.useForm();

  const [loading, setLoading] = useState(false);
  const [containerSize, setContainerSize] = useState([]);
  const [containers, setContainers] = useState([])
  const [pagination, setPagination] = useState({ current: 1, total: 0, pageSize: 10 });

  const location = useLocation();
  const state = location.state;
  const editMode = location.state?.isEdit ?? false;

  const columns = [
    {
      title: "S.no",
      dataIndex: "Sno",
      key: "Sno",
      render: (text, record, index) => index + 1,
    },
    {
      title: "Ref#",
      dataIndex: ["vehicle", "file_ref"],
      key: "Ref",
    },
    {
      title: "Year",
      dataIndex: ["vehicle", "year"],
      key: "Year",
    },
    {
      title: "Make / Model",
      dataIndex: "vehicle",
      key: "MakeModel",
      render: (text) => `${text.vehicle} / ${text.product ?? ''}`
    },
    {
      title: "Vin Numbers",
      dataIndex: ["vehicle", "chasis_no"],
      key: "VinNumbers",
    },
    {
      title: "Keys",
      dataIndex: ["vehicle", "keys"],
      key: "Keys",
    },
  ];

  const initialize = async (page = 1, pageSize = pagination.current) => {
    const { success, data } = await loadingPlanService.View(id, page);
    if (success) {
      setContainers(data.containers.data);
      setPagination((prev) => ({
        ...prev,
        total: data.containers.total,
        current: page,
        pageSize,
      }));
      form.setFieldsValue({ ...data.container })
      if (state) {
        form.setFieldsValue({
          seal_number: state.sealNo,
          verifier_name: state.verifier,
          note: state.note
        })
      }
    }
  };

  const onFinish = async (values) => {
    const data = {
      load_number: values.container_id,
      booking_number: containers[0].c_booking_number,
      c_container_number: values.c_container_number,
      seal_number: values.seal_number,
      container_size: values.container_size,
      verifier_name: values.verifier_name,
      container_id: values.container_id,
      note: values.note,
    }
    // console.log(data)
    setLoading(true);
    const response = await loadingPlanService.generatePDF(data, values.container_id);
    setLoading(false);
    if (response?.success ?? false) {
      navigate(`/operations/loadings/pdf/${values.container_id}`);
    }
  }

  const getContainerSizes = async () => {
    const { success, data } = await dropdownService.fetchContainerSizes();
    if (success) {
      setContainerSize(data);
    }
  }

  useEffect(() => {
    initialize(pagination.current, pagination.pageSize);
    getContainerSizes();

  }, [pagination.current, pagination.pageSize]);

  return (
    <div
      style={{
        padding: "12px 14px",
        border: "1px solid #ccc",
        borderRadius: "8px",
        backgroundColor: "#FFFFFF",
        paddingBottom: 20,
      }}
    >
      <Form
        // requiredMark={false}
        onFinish={onFinish}
        layout="vertical"
        form={form}
        initialValues={{ layout: "vertical" }}
      >
        <Row gutter={24}>
          <Col span={5}>
            <Form.Item label={"Load Number"} name="container_id">
              <Input placeholder="" disabled />
            </Form.Item>
          </Col>
          <Col span={5}>
            <Form.Item label="Container Number" name="c_container_number">
              <Input placeholder=""  disabled />
            </Form.Item>
          </Col>
          <Col span={5}>
            <Form.Item label="Seal Number" name="seal_number"
              rules={[
                {
                  required: true,
                  message: "Please input!",
                },
              ]}>
              <Input placeholder="" />
            </Form.Item>
          </Col>
          <Col span={4}>
            <Form.Item
              label="Container Size"
              name="container_size"

            >
              <Select placeholder="" disabled >
                {containerSize.map((size) => (
                  <Select.Option key={size.id} value={size.id}>
                    {size.name}
                  </Select.Option>))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={5}>
            <Form.Item label="Verifier Name" name="verifier_name"
              rules={[
                {
                  required: true,
                  message: "Please input!",
                },
              ]}>
              <Input placeholder="" />
            </Form.Item>
          </Col>
        </Row>

        <Table
          columns={columns}
          scroll={{ x: "max-content" }}
          dataSource={containers}
          style={{ marginTop: "20px" }}
          pagination={false}
        />
        <br />
        <Row gutter={16} align="bottom">
          <Col span={12}>
            <Form.Item label="Special Note:" name="note">
              <Input.TextArea placeholder="Enter special notes here..." rows={5} />
            </Form.Item>
          </Col>

          <Col span={12} style={{ textAlign: "right" }}>
            <Button type="primary" style={{ width: '70%' }} htmlType="submit" loading={loading}>
              {editMode ? `Update PDF` : "Generate PDF"}
            </Button>
          </Col>
        </Row>
      </Form>
    </div>
  );
}

export default GenerateLoadPlan;
